import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';

type Unpack<T> = T extends (dispatch: any) => infer TReturn ? TReturn : T;

type AnyFunction = (...args: any[]) => any;

export default function useAction<T extends AnyFunction>(
  action: T,
  deps: any[] = [],
): (...args: Parameters<T>) => Unpack<ReturnType<T>> {
  const dispatch = useDispatch();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(() => bindActionCreators(action, dispatch), [dispatch, ...deps]);
}
